// extracted by mini-css-extract-plugin
export default {"mainHeading":"Qtioz","mainIcon":"eVVSp","mainParagraph":"bHzB7","mainWrapper":"RGQ5C","page":"twOQ1","tablet":"Vq38r","desktop":"CnPgi"};